import _ from 'lodash'
import Backbone from 'backbone'

var ToggleAllCheckboxes = Backbone.View.extend({

	/**
	 * Implements a checkbox toggler that toggles all checkboxes, and also
	 * displays the state of whether or not all checkboxes are checked.  You
	 * pass in an element which contains all the checkboxes.  The first checkbox
	 * will be the "toggle all" checkbox, and all the others are the individual
	 * checkboxes.  The rules are as follows:
	 *
	 * <ul>
	 * <li>If the toggle all checkbox becomes checked, all the other checkboxes
	 * will also become checked</li>
	 * <li>If all the individual checkboxes become checked, the toggle all
	 * checkbox will also become checked (only if !options.deselectAll)</li>
	 * <li>If options.deselectAll, if the toggle all checkbox is unchecked, all
	 * the other checkboxes will also become unchecked</li>
	 * </ul>
	 *
	 * Examples:
	 * Admin > Groups > Advanced
	 * Datasets > New Dataset > last step of wizard
	 * Dataset > Edit > Permissions >  Actions checkboxes
	 *
	 * Note: This component does not perform well when needing to bind over
	 * large number of checkboxes
	 *
	 * @constructs
	 *
	 * @param {Object} options
	 *
	 * @param {Object} options.el the element containing all the checkboxes
	 *
	 * @param {Boolean} options.deselectAll (optional, default true).  If true,
	 * indicates that deselecting the toggle all checkbox should deselect all
	 * the other checkboxes.
	 */
	initialize: function(options = {}) {
		this.options = _.extend({
			deselectAll: true
		}, options)
	},

	events: {
		'change input[type=checkbox]:first': 'onClickToggleCheckbox',
		'change input[type=checkbox]:not(:first)': 'toggleToggleCheckbox'
	},

	render: function() {
		this.toggleToggleCheckbox()
		return this
	},

	getToggleAllCheckbox: function() {
		return this.$('input[type=checkbox]:visible:first')
	},

	getIndividualCheckboxes: function() {
		return this.$('input[type=checkbox]:visible:not(:first)')
	},

	/**
	 * Handles clicks on the toggle all checkbox based on the rules described
	 * in the comments for the initialize method
	 */
	onClickToggleCheckbox: function() {
		var checked = this.getToggleAllCheckbox().prop('checked')
		if (checked || (!checked && this.options.deselectAll)) {
			//#46821 do not emit a change event here as this will fire n times
			//the number of checkboxes due to the event listeners defined in this view
			this.getIndividualCheckboxes().prop('checked', checked)
		}
		this.trigger('toggleAll', this.getToggleAllCheckbox().prop('checked'))

		// #55869
		// Allow views to listen for a trigger that can be used to uncheck
		// disabled permissions
		this.trigger('change')
	},

	/**
	 * Checks or unchecks the toggle all checkbox based on the status of the
	 * individual checkboxes.
	 */
	toggleToggleCheckbox: function() {
		let isToggleAllChecked = this.getToggleAllCheckbox().prop('checked')
		let allChecked = _.every(this.getIndividualCheckboxes(), (el) =>
			this.$(el).prop('checked')
		)
		// #14285 if all checkboxes are checked, the "toggle all" checkbox
		// should also be checked
		if (allChecked) {
			this.getToggleAllCheckbox().prop('checked', true)
			if (!isToggleAllChecked) {
				this.trigger('toggleAll', true)
			}
		}
		if (this.options.deselectAll && !allChecked) {
			this.getToggleAllCheckbox().prop('checked', false)
			if (isToggleAllChecked) {
				this.trigger('toggleAll', false)
			}
		}
	}

})

export default ToggleAllCheckboxes

ToggleAllCheckboxes.__filename__ = 'components/toggle-all-checkboxes.js'
